import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Users } from 'app/_models/users';
import { AppRoles } from 'app/_models/roles';
import { RegisterUserModel } from 'app/_models/user-model';
import { Observable } from 'rxjs';
import { UserStatus } from 'app/_models/user-status';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  _baseUrl = environment.baseUrl;
  constructor(private readonly http: HttpClient) { }

  getUsers(): Observable<Users[]> {
    return this.http.get<Users[]>(`${this._baseUrl}account/getUsers`);
  }

  updateUser(model: any): Observable<any> {
    return this.http.post<any>(`${this._baseUrl}Account/UpdateAppUser`, model);
  }

  addUser(model:any): Observable<RegisterUserModel> {
    return this.http.post<RegisterUserModel>(`${this._baseUrl}Account/register`, model);
  }

  addBulkUsers(model:any): Observable<any> {
    return this.http.post<any>(`${this._baseUrl}Account/bulkRegister`, model);
  }

  getUserStatus(): Observable<UserStatus[]> {
    return this.http.get<UserStatus[]>(`${this._baseUrl}account/getUserStatus`);
  }

  getRoles(): Observable<AppRoles[]> {
    return this.http.get<AppRoles[]>(`${this._baseUrl}account/getRoles`);
  }
}
